import Banner from '../../components/cards/advt-card/0-banner';
import NewsCarousel from '../../components/cards/advt-card/4-carousel';

const SecondaryData = () => {
  return (
    <div>
      <Banner />
      <NewsCarousel />
    </div>
  );
};

export default SecondaryData;